import { Pipe, PipeTransform } from '@angular/core';

export const formatBytes = (bytes: number, decimals = 2) => {
	const value = Number(bytes);
	if (!Number.isFinite(value) || value <= 0) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const exponent = Math.floor(Math.log(value) / Math.log(k));
	const i = Math.min(Math.max(exponent, 0), sizes.length - 1);

	return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

@Pipe({
	name: 'lbcaFormatBytes',
})
export class LbcaFormatBytesPipe implements PipeTransform {
	transform(bytes: number | undefined, decimals = 2): string {
		if (!bytes || typeof bytes != 'number') return '0 Bytes';

		return formatBytes(bytes, decimals);
	}
}
